export default __webpack_public_path__ + "static/media/5296765_camera_instagram_instagram logo_icon.2508c52a.png";